import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

interface LeagueProps {
  data: any
}

export interface ViewProps {
  nav: string;
  title: string;
  comp: React.ComponentType<LeagueProps>;
}

export interface ContextNavProps {
  selectedView: ViewProps;
  setView: (v: ViewProps) => void;
  views: ViewProps[];
}

export function ContextNavbar(props: ContextNavProps) {

  const selectNav = (v: string | null,e: React.BaseSyntheticEvent) => {
    e.preventDefault();
    const view = props.views.find((s) => s.nav === v);
    if (view) {
      props.setView(view);
    }
  }

  return (
    <Navbar expand={false} onSelect={selectNav}>
      <Container>
        <Navbar.Brand>
            <NavDropdown title={props.selectedView.title} id="basic-nav-dropdown">
              {props.views.map((v) => {
                return <NavDropdown.Item key={v.nav} href={v.nav}>{v.title}</NavDropdown.Item>
              })}
            </NavDropdown>
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
}
